/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-body',
    template: '<ng-content></ng-content>'
})
export class ModalBodyComponent {
}
